<header-bar title="Account Einstellungen"></header-bar>
<div class="page-content">

  <div class="card card-style mt-3" style="background-color: white!important;">
    <div class="content">
      <h1>Dein Account</h1>
      <table class="font-weight-bolder">
        <tr>
          <td style="padding-right: 12px">Registriert am:</td>
          <td><%= currentUser.getMomentCreated().format( 'DD.MM.YYYY' ) %></td>
        </tr>
        <tr>
          <td>E-Mail:</td>
          <td><%= currentUser.get( 'email' ) %></td>
        </tr>
        <tr>
          <td>Name:</td>
          <td><%= currentUser.get( 'name' ) %></td>
        </tr>
        <!--
        <tr>
          <td colspan="2">
            <mark class="highlight ps-2 font-12 pe-2" style="background-color: #4eb9aa !important; color: white!important;">Um deinen Account zu löschen, schreibe einfach eine Mail an <a href="mailto:support@youtine.de" target="_blank">support@youtine.de</a></mark>
          </td>
        </tr>
        -->
      </table>
    </div>
  </div>

  <div class="card card-style mt-3" style="background-color: white!important;">
    <div class="content">
      <h4 class="text-primary">Namen ändern</h4>
      <p class="font-weight-bolder">
        Ändere deinen Namen.
      </p>
      <form data-id="formName">
        <input type="name"
               class="form-control validate-name font-weight-bolder"
               style="border-radius: 8px; padding: 12px 6px"
               id="form1"
               value="<%= currentUser.get( 'name' ) %>"
               required
               minlength="2"
               maxlength="32"
               name="newName"
               placeholder="Name">
        <div class="error-hint">
          Bitte Spitznamen mit mindestens 2 Zeichen eingeben.
        </div>
      </form>
      <button data-id="btnChangeName"
              class="btn btn-s btn-full mb-3 mt-3 rounded-xl text-uppercase font-700 shadow-s bg-primary">Namen aktualisieren</button>
    </div>
  </div>


  <div class="card card-style mt-3" style="background-color: white!important;">
    <div class="content">
      <h4 class="text-primary">Passwort ändern</h4>
      <p class="font-weight-bolder">
        Ändere dein Passwort.
      </p>
      <form data-id="formPassword">
        <input type="password"
               name="oldPassword"
               required
               class="form-control validate-name font-weight-bolder"
               style="border-radius: 8px; padding: 12px 6px"
               placeholder="Bisheriges Passwort">
        <div class="error-hint">
          Bitte angeben.
        </div>
        <input type="password"
               name="newPassword"
               minlength="6"
               maxlength="32"
               required
               class="form-control validate-name mt-3 font-weight-bolder"
               style="border-radius: 8px; padding: 12px 6px"
               placeholder="Neues Passwort">
        <div class="error-hint">
          Das Passwort muss mindestens aus 6 Zeichen bestehen.
        </div>
      </form>
      <button data-id="btnChangePassword"
              class="btn btn-s btn-full mb-3 mt-3 rounded-xl text-uppercase font-700 shadow-s bg-primary">Passwort aktualisieren</button>
    </div>
  </div>

</div>
<main-menu></main-menu>
